module.exports = __webpack_public_path__ + "1a8ad8be6088810f1990b8fef7ed92bf.svg";